<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useToast } from 'primevue/usetoast';
import axiosInstance from '@/plugins/axios';
;

const toast = useToast();
const files = ref([]);
const blocked = ref(false);

const blockDocument = () => {
    blocked.value = true;
    setTimeout(() => {
        blocked.value = false;
        toast.add({ severity: 'success', summary: 'Erfolg', detail: `Backup erfolgreich.` });
        getBackups();
    }, 3000);

}

const makeBackup = async (collectionName) => {
  try {
    const response = await axiosInstance.
get(`/db/export/${collectionName}`);
    blockDocument();
  } catch (error) {
    console.error('Failed to load exported files:', error);
    toast.add({ severity: 'error', summary: 'Fehler', detail: `Fehler beim erstellen eines Bsckups.` });
  }
};

const fullBackup = async () => {
  try {
    const response = await axiosInstance.
get(`/db/exports/fullBackup`);
    blockDocument();
  } catch (error) {
    console.error('Failed to load exported files:', error);
    toast.add({ severity: 'error', summary: 'Fehler', detail: `Fehler beim erstellen eines Bsckups.` });
  }
};

const getBackups = async () => {
  try {
    const response = await axiosInstance.
get('/db/exports/fileList');
    files.value = response.data.map(file => {
      const match = file.name.match(/^(.*)-(\d{4}-\d{2}-\d{2}T\d{2}-\d{2}-\d{2})\.json$/);
      if (match) {
        return { name: match[1], date: match[2], url: file.url };
      }
      return file;
    });
  } catch (error) {
    console.error('Failed to load exported files:', error);
  }
};

const downloadFile = async (fileUrl) => {
  try {
    const response = await axiosInstance.get('/db/exports/download/' + fileUrl, {
      responseType: 'blob', 
 
    });

    // Erstellen eines URLs aus dem Blob
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileUrl); 
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);  
  } catch (error) {
    console.error('Failed to download:', error);
  }
};


const deleteFile = async (fileName) => {
  try {
    await axiosInstance.
delete(`/db/exports/${fileName}`);
    getBackups(); // Aktualisiere die Liste nach dem Löschen
  } catch (error) {
    console.error('Failed to delete file:', error);
  }
};


onMounted( async () => {

  await getBackups();

})

</script>

<template>
  <div>
    <div class="col-12">
      <div class="surface-section px-4 py-5 ">
        <div class="flex align-items-start flex-column lg:justify-content-between lg:flex-row">
          <div>
            <div class="font-medium text-3xl text-900">Exports</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <ProgressSpinner v-if="blocked" />
      <BlockUI :blocked="blocked" fullScreen />

      <Card class="col-3 m-2 text-center menuCard" @click="makeBackup('questions')">
        <template #title>
          Fragen
        </template>
        <template #content>
          <font-awesome-icon :icon="['fas', 'download']" />&nbsp;
        </template>
      </Card>
      <Card class="col-3 m-2 text-center menuCard" @click="makeBackup('options')">
        <template #title>
          Optionen
        </template>
        <template #content>
          <font-awesome-icon :icon="['fas', 'download']" />&nbsp;
        </template>
      </Card>
      <Card class="col-3 m-2 text-center menuCard" @click="makeBackup('evaluations')">
        <template #title>
          Ergebnisseiten
        </template>
        <template #content>
          <font-awesome-icon :icon="['fas', 'download']" />&nbsp;
        </template>
      </Card>
      <Card class="col-3 m-2 text-center menuCard" @click="fullBackup">
        <template #title>
          Kompletter Backup
        </template>
        <template #content>
          <font-awesome-icon :icon="['fas', 'download']" />&nbsp;
        </template>
      </Card>
      <DataTable :value="files" class="col-10 data-table mb-5 mt-3 text-center justify-content-center">
        <template #header>
        <div class="flex flex-wrap align-items-center justify-content-between gap-2">
            <span class="text-xl text-900 font-bold"></span>
            <Button rounded raised @click="getBackups" label="Refresh">
              <template #icon>
                <FontAwesomeIcon icon="refresh" />
              </template>
            </Button>
        </div>
    </template>
    <Column field="name" header="Dateiname"></Column>
    <Column header="Aktionen" bodyScope class="text-center justify-content-center">
      <template #body="slotProps">
        <Button @click="downloadFile(slotProps.data.name)" class="rounded">
        <template #icon>
          <FontAwesomeIcon icon="download" />
        </template>
        </Button>
        <Button @click="deleteFile(slotProps.data.name)" class="rounded ml-3" severity="danger">
        <template #icon>
          <FontAwesomeIcon icon="trash" />
          </template>
        </Button>
      </template>
    </Column>
  </DataTable>
    </div>

  </div>
  </template>
<style scoped>
.menuCard {
    cursor: pointer;
    transition: 1ms;
}
.menuCard:hover {
    background-color: #00dce6;
    color: white
}
.menuCard {
    cursor: pointer;
    transition: 0.3s;
}

.menuCard:hover {
    background-color: #00dce6;
    color: white;
}

.data-table {
    border-collapse: collapse;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.data-table th {
    background-color: #f1f1f1;
    color: #333;
    font-weight: 500;
    text-align: left;
    padding: 12px 15px;
    border-bottom: 2px solid #dee2e6;
}

.data-table td {
    padding: 10px 15px;
    border-bottom: 1px solid #dee2e6;
    color: #666;
}

.data-table tr:hover {
    background-color: #f9f9f9;
}

.data-table tr:last-child td {
    border-bottom: none;
}

.button-icon {
    cursor: pointer;
    color: #0c63e4;
    transition: color 0.2s;
}

.button-icon:hover {
    color: #0949ab;
}

</style>